function addCssLink(href: string): HTMLLinkElement {
	const stylesheet = document.createElement("link");
	const refs = (document.body || document.getElementsByTagName("head")[0]).childNodes;
	const ref = refs[refs.length - 1];
	stylesheet.rel = "stylesheet";
	stylesheet.href = href;
	// temporarily set media to something inapplicable to ensure it'll fetch without blocking render
	stylesheet.media = "only x";

	// wait until body is defined before injecting link. This ensures a non-blocking load in IE11.
	function ready(callback) {
		if (document.body) {
			return callback();
		}

		setTimeout(function () {
			ready(callback);
		});
	}

	// Inject link
	// Note: the ternary preserves the existing behavior of "before" argument, but we could choose to change the argument to "after" in a later release and standardize on ref.nextSibling for all refs
	// Note: `insertBefore` is used instead of `appendChild`, for safety re: http://www.paulirish.com/2011/surefire-dom-element-insertion/
	ready(function () {
		if (ref.parentNode) {
			ref.parentNode.insertBefore(stylesheet, ref.nextSibling);
		}
	});

	function loadCallback() {
		stylesheet.removeEventListener("load", loadCallback);
		stylesheet.media = "all";
	}

	// once loaded, set link's media back to `all` so that the stylesheet applies once it loads
	stylesheet.addEventListener("load", loadCallback);
	return stylesheet;
}

function loadCss(filename: string): Promise<any> {
	addCssLink(filename);
	return Promise.resolve("CSS loaded for " + filename);
}

export const AsyncLoader = {
	loadCss: loadCss,
};
